module.exports = __webpack_public_path__ + "static/img/declare_four.9dbdd33.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/declare_four.jpg
// module id = RxO+
// module chunks = 1